export default "__VITE_ASSET__Cs6XV7a3__"